import {
  StyledListItemText,
  StyledListitem,
} from '@/components/ProductDetailsSpecificationsList/ProductDetailsSpecifications.styled'

import type * as React from 'react'
import type { SxProps } from '@mui/material'

interface Props {
  listItem?: React.ReactNode
  labelItem: React.ReactNode
  sx?: SxProps
}
export const SpecificationsListItem: React.FC<Props> = ({ listItem, labelItem, sx }) => {
  if (listItem) {
    return (
      <StyledListitem sx={{ ...sx }}>
        <StyledListItemText primary={labelItem} secondary={listItem} />
      </StyledListitem>
    )
  }

  return null
}
